import {OpenGraph} from 'next/dist/lib/metadata/types/opengraph-types'

import {Locale} from '@/utils/constants'
import {getAbsoluteUrl} from '@/utils/i18n'
import {getPathLocales} from '@/utils/i18n/restrictedPaths'
import {routing} from '@/utils/i18n/routing'
import {DEFAULT_HOST} from '@/utils/router'

export const generateDefaultOpenGraphMetadata = (locale: Locale): OpenGraph => {
  const isEnLanguage = locale === Locale.en
  const ogImageSrc = `${DEFAULT_HOST}/images/og-images/${
    isEnLanguage ? 'og-image-en.png' : 'og-image.png'
  }`

  return {
    images: {
      url: ogImageSrc,
      width: 1200,
      height: 627,
      alt: 'OG image',
    },
  }
}

// alternateLocales: undefined = the locales utils/i18n/restrictedPaths.ts serves the path in, [] = no alternates
export const generateDefaultAlternates = (
  path: string,
  locale: Locale,
  alternateLocales?: Locale[],
) => {
  const locales = alternateLocales ?? getPathLocales(path)
  const defaultLocale = routing.defaultLocale as Locale
  // The page itself when it has no default-locale copy: a Slovak-only article must not point
  // `x-default` at an English URL that 404s.
  const xDefaultLocale = locales.includes(defaultLocale) ? defaultLocale : locale

  return {
    canonical: getAbsoluteUrl(path, locale),
    languages: {
      'x-default': getAbsoluteUrl(path, xDefaultLocale),
      ...Object.fromEntries(
        locales.map((locale) => [locale, getAbsoluteUrl(path, locale as Locale)]),
      ),
    },
  }
}
